import Login from 'src/pages/Login'
import PlaylistList from 'src/pages/Playlist'
import Metaverse from 'src/pages/Metaverse'
import EditMetaverse from 'src/pages/Metaverse/EditMetaverse'
import Maze from 'src/pages/Maze'
import EditMaze from 'src/pages/Maze/EditMaze'
import Game from 'src/pages/Games'
import SurvivalZone from 'src/pages/SurvivalZone'
import EditSurvivalZone from './pages/SurvivalZone/editsurvivalzone'
import TreasureHunter from 'src/pages/TreasureHunter'
import EditTreasureHunter from './pages/TreasureHunter/edittreasurehunter'
import EditGames from 'src/pages/Games/EditGames'
import ArenaGames from 'src/pages/Arena/Games'
import EditArenaGame from 'src/pages/Arena/Games/EditArenaGame'
import ArenaTournaments from 'src/pages/Arena/Tournaments'
import ArenaDailyChallenges from 'src/pages/Arena/DailyChallenges'
import EditDailyChallenge from 'src/pages/Arena/DailyChallenges/EditDailyChallenge'
import Marketplace from 'src/pages/Marketplace'
import EditMarketplace from 'src/pages/Marketplace/EditMarketplace'
import AddMarketplace from 'src/pages/Marketplace/AddMarketplace'
import MonhtlyMarketplace from 'src/pages/Marketplace/MonhtlyMarketplace'
import RedeemUsers from 'src/pages/Users/RedeemUsers'
import RedeemCodePage from 'src/pages/RedeemCodes'

import MafEvents from 'src/pages/Events'
import LeaderboardEvents from 'src/pages/Events/Leaderboard'
import Prices from 'src/pages/Events/Prices'
import EditMarketplaceEvent from 'src/pages/Events/Prices/EditMarketplaceEvent'

import LoggedInUsers from 'src/pages/Users/LoggedInUsers'
import UserDeleteAccountPage from 'src/pages/Users/UserDeleteAccount/userDeleteAccount'
import MonthlyWinners from 'src/pages/Marketplace/MonthlyWinners'
import Bots from 'src/pages/Social/Bots'
import PlaylistDetail from 'src/pages/Playlist/Detail'
import TrackList from 'src/pages/Track'
import StationList from 'src/pages/Station'
import StationDetail from 'src/pages/Station/Detail'
import TagList from 'src/pages/Tag/Music'
import TagDetail from 'src/pages/Tag/Music/Detail'
import GameTagPage from 'src/pages/Tag/Games'
import Character from 'src/pages/Character/Main'
import EditCharacter from 'src/pages/Character/Main/EditCharacter'

import PlaylistImages from 'src/pages/Image/playlist'
import UsersList from 'src/pages/Users/user'
import PlaylistReport from 'src/pages/Reports/PlaylistReport/playlistReport'
import StationReport from 'src/pages/Reports/StationsReport/stationReport'
import TracksReport from 'src/pages/Reports/TracksReport/tracksReport'
import AppUsageReport from 'src/pages/Reports/AppUsageReport/appUsageReport'
import MetaverseReport from 'src/pages/Reports/MetaverseReport/metaverseReport'

import MazeReport from 'src/pages/Reports/MazeReport/mazeReport'

import UserSearchReport from 'src/pages/Reports/UserSearchReport/userSearchReport'
import ProfileChangeReport from 'src/pages/Reports/UserProfileChangeReport/userProfileChangeReport'
import GameUsageReport from 'src/pages/Reports/GameUsageReport/gameUsageReport'
import PlaylistDiscovery from './pages/Discovery/Playlists'
import TrackDiscovery from './pages/Discovery/Tracks'
import Faq from 'src/pages/Faq'
import Abuse from 'src/pages/Abuse'
import MetaverseDiscovery from './pages/Discovery/Metaverse'
import MazeDiscovery from './pages/Discovery/Mazes'
import Unauthorized from './pages/unauthorized/unauthorized'
import Welcome from './pages/welcome/welcome'
import Admin from './pages/Admin'
import Audit from './pages/Audit'
import Post from './pages/Social/Post'
import BotPost from './pages/Social/BotPost'
import BotChats from './pages/Social/BotChats'
import ViewComment from './pages/Social/BotPost/ViewComment'

import Message from './pages/Social/Message'
import UserPosts from './pages/Social/UserPost'
import AbuseReason from './pages/Social/Abuse'
import SocialOverview from './pages/Dashboard/SocialOverview'
import StationDiscovery from './pages/Discovery/Stations'
import LayoutDiscovery from './pages/Discovery/Layout'
import RedeemUserDashboard from './pages/Dashboard/RedeemUser'
import LayoutCharacter from 'src/pages/Character/Layout'
import TreasureHunterReport from 'src/pages/Reports/TreasureHunterReport/treasureHunterReport'
import ChatUsageReport from './pages/Reports/ChatUsageReport/chatUsageReport'
import MarketplaceUsageReport from './pages/Reports/MarketplaceUsageReport/marketplaceUsageReport'
import UserprofileUsageReportPage from './pages/Reports/UserProfileUsageReport/userprofileUsageReport'
import SelectAvatarUsageReportPage from './pages/Reports/SelectAvatarUsageReport/selectAvatarUsageReport'
import CreateAvatarUsageReportPage from './pages/Reports/CreateAvatarUsageReport/createAvatarUsageReport'
import SocialUsageReport from './pages/Reports/SocialUsageReport/socialUsageReport'
import QuizPage from './pages/Quizs/QuizPage'
import SurvivorZoneReport from './pages/Reports/SurvivorZonezreport/survivorZoneReport'
import AvatarReport from './pages/Reports/AvatarReport/avatarReport'
import Dashboard from './pages/welcome/Dashboard'
import MainDiscovery from './pages/Discovery/Main'
import TreasureHunterLeaderBoard from './pages/Leaderboard/TreasureHunter'
import MazeLeaderBoard from './pages/Leaderboard/Maze'
import GameLeaderBoard from './pages/Leaderboard/Game'
import SurvivalZoneLeaderBoard from './pages/Leaderboard/SurvivalZone'
import UserDetail from './pages/Users/user/userDetail'
import AvatarOverview from './pages/Dashboard/Avataroverview'
import UserJourneyReportPage from './pages/Reports/UserJourneyReport/userJourneyReport'
import AdsReport from 'src/pages/Reports/AdsReport/adsReport'
import TreasureRedeemReport from 'src/pages/Reports/TreasureRedeemReport/treasureRedeemReport'
import UserPointsReport from 'src/pages/Reports/UserPointsReport/userPointsReport'
import AllGames from './pages/AllGames/allGamesReport'
import CheaterAccessToken from 'src/pages/Cheaters/AccessToken'
import GamesAnomaly from 'src/pages/Cheaters/GamesAnomaly'
import TreasureAnomaly from 'src/pages/Cheaters/TreasureAnomaly'
import AccessToken from 'src/pages/Cheaters/AccessToken'

export default [
  {
    path: '/playlist',
    component: PlaylistList,
    protected: true,
    requiredprivileges: ['music', 'superadmin'],
  },
  {
    path: '/metaverse',
    component: Metaverse,
    protected: true,
    requiredprivileges: ['marketing', 'game-content', 'superadmin'],
  },
  {
    path: '/games',
    component: AllGames,
    protected: true,
    requiredprivileges: [
      'game-content',
      'moderator',
      'marketing',
      'superadmin',
    ],
  },
  {
    path: '/survival-zone',
    component: SurvivalZone,
    protected: true,
    requiredprivileges: [
      'game-content',
      'moderator',
      'marketing',
      'superadmin',
    ],
  },
  {
    path: '/survival-zone/edit/:id',
    component: EditSurvivalZone,
    protected: true,
    requiredprivileges: [
      'game-content',
      'moderator',
      'marketing',
      'superadmin',
    ],
  },
  {
    path: '/treasure-hunter',
    component: TreasureHunter,
    protected: true,
    requiredprivileges: [
      'game-content',
      'moderator',
      'marketing',
      'superadmin',
    ],
  },
  {
    path: '/treasure-hunter/edit/:id',
    component: EditTreasureHunter,
    protected: true,
    requiredprivileges: [
      'game-content',
      'moderator',
      'marketing',
      'superadmin',
    ],
  },
  {
    path: '/marketplace',
    component: Marketplace,
    protected: true,
    requiredprivileges: ['marketplace', 'superadmin'],
  },
  {
    path: '/marketplace/edit/:id',
    component: EditMarketplace,
    protected: true,
    requiredprivileges: ['marketplace', 'superadmin'],
  },
  {
    path: '/games/edit/:id',
    component: EditGames,
    protected: true,
    requiredprivileges: [
      'game-content',
      'moderator',
      'marketing',
      'superadmin',
    ],
  },
  {
    path: '/arena/games',
    component: ArenaGames,
    protected: true,
    requiredprivileges: ['marketing', 'arena-content','superadmin'],
  },
  {
    path: '/arena/games/edit/:id',
    component: EditArenaGame,
    protected: true,
    requiredprivileges: ['marketing', 'arena-content','superadmin'],
  },
  {
    path: '/arena/tournaments',
    component: ArenaTournaments,
    protected: true,
    requiredprivileges: ['marketing', 'arena-content','superadmin'],
  },
  {
    path: '/arena/daily-challenges',
    component: ArenaDailyChallenges,
    protected: true,
    requiredprivileges: ['marketing', 'arena-content','superadmin'],
  },
  {
    path: '/arena/daily-challenges/edit/:id',
    component: EditDailyChallenge,
    protected: true,
    requiredprivileges: ['marketing', 'arena-content', 'superadmin'],
  },
  {
    path: '/metaverse/edit/:id',
    component: EditMetaverse,
    protected: true,
    requiredprivileges: ['marketing', 'game-content', 'superadmin'],
  },

  {
    path: '/maze/edit/:id',
    component: EditMaze,
    protected: true,
    requiredprivileges: [
      'game-content',
      'moderator',
      'marketing',
      'superadmin',
    ],
  },
  {
    path: '/marketplace/add',
    component: AddMarketplace,
    protected: true,
    requiredprivileges: ['marketplace', 'superadmin'],
  },
  {
    path: '/marketplace/monthly',
    component: MonhtlyMarketplace,
    protected: true,
    requiredprivileges: ['marketplace', 'superadmin'],
  },
  {
    path: '/leaderboard/monthly/winners',
    component: MonthlyWinners,
    protected: true,
    requiredprivileges: [
      'finance',
      'support',
      'marketing',
      'moderator',
      'superadmin',
    ],
  },
  {
    path: '/maze',
    component: Maze,
    protected: true,
    requiredprivileges: [
      'game-content',
      'moderator',
      'marketing',
      'superadmin',
    ],
  },
  {
    path: '/faq',
    component: Faq,
    protected: true,
    requiredprivileges: ['game-content', 'marketing', 'superadmin'],
  },
  {
    path: '/abuse',
    component: Abuse,
    protected: true,
    requiredprivileges: ['game-content', 'superadmin'],
  },
  {
    path: '/playlist/:id',
    component: PlaylistDetail,
    protected: true,
    requiredprivileges: ['music', 'superadmin'],
  },

  {
    path: '/track',
    component: TrackList,
    protected: true,
    requiredprivileges: ['music', 'superadmin'],
  },
  {
    path: '/station',
    component: StationList,
    protected: true,
    requiredprivileges: ['music', 'superadmin'],
  },
  {
    path: '/station/:id',
    component: StationDetail,
    protected: true,
    requiredprivileges: ['music', 'superadmin'],
  },
  {
    path: '/login',
    component: Login,
    protected: false,
    blankLayout: true,
  },
  {
    path: '/tags/music',
    component: TagList,
    protected: true,
    requiredprivileges: ['support', 'marketing', 'music', 'superadmin'],
  },
  {
    path: '/tags/music/:id',
    component: TagDetail,
    protected: true,
    requiredprivileges: ['support', 'marketing', 'music', 'superadmin'],
  },
  {
    path: '/tags/games',
    component: GameTagPage,
    protected: true,
    requiredprivileges: ['game-content', 'support', 'marketing', 'superadmin'],
  },
  {
    path: '/image/playlist',
    component: PlaylistImages,
    protected: true,
    requiredprivileges: ['music', 'superadmin', 'marketplace'],
  },
  {
    path: '/users/users',
    component: UsersList,
    protected: true,
    requiredprivileges: ['finance', 'support', 'superadmin', 'marketplace', 'moderator'],
  },
  {
    path: '/users/detail/:userName',
    component: UserDetail,
    protected: true,
    requiredprivileges: ['finance', 'support', 'superadmin', 'marketplace', 'moderator'],
  },
  {
    path: '/users/redeemUsers',
    component: RedeemUsers,
    protected: true,
    requiredprivileges: [
      'finance',
      'support',
      'moderator',
      'marketplace',
      'superadmin',
    ],
  },
  {
    path: '/users/loggedInUsers',
    component: LoggedInUsers,
    protected: true,
    requiredprivileges: ['finance', 'support', 'superadmin', 'marketplace', 'moderator'],
  },
  {
    path: '/users/delete',
    component: UserDeleteAccountPage,
    protected: true,
    requiredprivileges: ['finance', 'support', 'superadmin', 'marketplace'],
  },
  {
    path: '/reports/playlist-reports',
    component: PlaylistReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'music',
      'marketplace',
    ],
  },
  {
    path: '/reports/station-reports',
    component: StationReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'music',
      'marketplace',
    ],
  },
  {
    path: '/reports/tracks-reports',
    component: TracksReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'music',
      'marketplace',
    ],
  },
  {
    path: '/reports/appUsage-reports',
    component: AppUsageReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/reports/metaverse-reports',
    component: MetaverseReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'game-content',
      'marketplace',
    ],
  },
  {
    path: '/reports/maze-reports',
    component: MazeReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/reports/survivor-zone-report',
    component: SurvivorZoneReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/reports/usersSearch-reports',
    component: UserSearchReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/reports/userProfileChange-reports',
    component: ProfileChangeReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/reports/gameUsage-reports',
    component: GameUsageReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/reports/ads-reports',
    component: AdsReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/reports/treasure-redeem-reports',
    component: TreasureRedeemReport,
    protected: true,
    requiredprivileges: ['report', 'superadmin', 'marketplace'],
  },
  {
    path: '/reports/user-points-reports',
    component: UserPointsReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/discovery/main-discovery',
    component: MainDiscovery,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'superadmin'],
  },
  {
    path: '/discovery/playlist-discovery',
    component: PlaylistDiscovery,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'music', 'superadmin'],
  },
  {
    path: '/discovery/tracks-discovery',
    component: TrackDiscovery,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'music', 'superadmin'],
  },
  {
    path: '/discovery/metaverse-discovery',
    component: MetaverseDiscovery,
    protected: true,
    requiredprivileges: [
      'marketing',
      'moderator',
      'superadmin',
      'game-content',
    ],
  },
  {
    path: '/discovery/maze-discovery',
    component: MazeDiscovery,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'superadmin'],
  },
  {
    path: '/welcome',
    component: Welcome,
    protected: true,
  },
  {
    path: '/dashboard',
    component: Dashboard,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'moderator',
      'support',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },

  {
    path: '/access',
    component: Admin,
    protected: true,
    requiredprivileges: ['superadmin'],
  },
  {
    path: '/audit',
    component: Audit,
    protected: true,
    requiredprivileges: ['superadmin'],
  },
  {
    path: '/quiz',
    component: QuizPage,
    protected: true,
    requiredprivileges: ['marketing', 'game-content', 'superadmin'],
  },
  {
    path: '/social/post',
    component: Post,
    protected: true,
    requiredprivileges: ['marketing', 'superadmin', 'social'],
  },
  {
    path: '/social/message',
    component: Message,
    protected: true,
    requiredprivileges: ['marketing', 'superadmin', 'social'],
  },
  {
    path: '/social/post',
    component: Post,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'superadmin'],
  },
  {
    path: '/social/bot-posts',
    component: BotPost,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'superadmin'],
  },
  {
    path: '/social/bot-chats',
    component: BotChats,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'superadmin'],
  },
  {
    path: '/social/bot-post/comments/:id',
    component: ViewComment,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'superadmin'],
  },
  {
    path: '/social/user-posts/comments/:id',
    component: ViewComment,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'superadmin'],
  },
  {
    path: '/social/user-posts',
    component: UserPosts,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'superadmin'],
  },
  {
    path: '/social/user-posts/:id',
    component: UserPosts,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'superadmin'],
  },
  {
    path: '/social/abuse-reason',
    component: AbuseReason,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'superadmin'],
  },
  {
    path: '/social/bots',
    component: Bots,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'superadmin'],
  },
  {
    path: '/unauthorized',
    component: Unauthorized,
    protected: true,
  },
  {
    path: '/discovery/stations-discovery',
    component: StationDiscovery,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'music', 'superadmin'],
  },
  {
    path: '/reports/treasureHunter-reports',
    component: TreasureHunterReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/reports/chatUsage-reports',
    component: ChatUsageReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/reports/marketplace-usage-report',
    component: MarketplaceUsageReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/reports/userprofile-usage-report',
    component: UserprofileUsageReportPage,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/reports/select-avatar-usage-report',
    component: SelectAvatarUsageReportPage,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/reports/create-avatar-usage-report',
    component: CreateAvatarUsageReportPage,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/reports/socialUsage-reports',
    component: SocialUsageReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/reports/avatar-reports',
    component: AvatarReport,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/leaderboard/treasure-hunter',
    component: TreasureHunterLeaderBoard,
    protected: true,
    requiredprivileges: [
      'finance',
      'support',
      'marketing',
      'moderator',
      'superadmin',
    ],
  },
  {
    path: '/leaderboard/maze',
    component: MazeLeaderBoard,
    protected: true,
    requiredprivileges: [
      'finance',
      'support',
      'marketing',
      'moderator',
      'superadmin',
    ],
  },
  {
    path: '/leaderboard/game',
    component: GameLeaderBoard,
    protected: true,
    requiredprivileges: [
      'finance',
      'support',
      'marketing',
      'moderator',
      'superadmin',
    ],
  },
  {
    path: '/leaderboard/survival-zone',
    component: SurvivalZoneLeaderBoard,
    protected: true,
    requiredprivileges: [
      'finance',
      'support',
      'marketing',
      'moderator',
      'superadmin',
    ],
  },
  {
    path: '/characters/main',
    component: Character,
    protected: true,
    requiredprivileges: ['marketing', 'game-content', 'superadmin'],
  },
  {
    path: '/characters/main/edit/:id',
    component: EditCharacter,
    protected: true,
    requiredprivileges: ['marketing', 'game-content', 'superadmin'],
  },
  {
    path: '/characters/layout',
    component: LayoutCharacter,
    protected: true,
    requiredprivileges: ['marketing', 'game-content', 'superadmin'],
  },
  {
    path: '/dashboard/social',
    component: SocialOverview,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/dashboard/redeem',
    component: RedeemUserDashboard,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'moderator',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/dashboard/avatar',
    component: AvatarOverview,
    protected: true,
    requiredprivileges: [
      'reports',
      'finance',
      'support',
      'marketing',
      'superadmin',
      'marketplace',
    ],
  },
  {
    path: '/users/journey',
    component: UserJourneyReportPage,
    protected: true,
    requiredprivileges: ['finance', 'support', 'superadmin', 'marketplace'],
  },
  {
    path: '/events/prices',
    component: Prices,
    protected: true,
    requiredprivileges: [
      'marketing',
      'event-view',
      'superadmin',
      'game-content',
    ],
  },
  {
    path: '/events/prices/edit/:id',
    component: EditMarketplaceEvent,
    protected: true,
    requiredprivileges: [
      'marketing',
      'game-content',
      'superadmin',
      'game-content',
    ],
  },
  {
    path: '/events/maf',
    component: MafEvents,
    protected: true,
    requiredprivileges: [
      'marketing',
      'game-content',
      'superadmin',
      'game-content',
    ],
  },
  {
    path: '/events/leaderboard',
    component: LeaderboardEvents,
    protected: true,
    requiredprivileges: ['marketing', 'game-content', 'superadmin'],
  },
  {
    path: '/discovery/layout',
    component: LayoutDiscovery,
    protected: true,
    requiredprivileges: ['marketing', 'moderator', 'superadmin'],
  },
  {
    path: '/redeem-codes',
    component: RedeemCodePage,
    protected: true,
    requiredprivileges: ['superadmin'],
  },
  {
    path: '/AllGames',
    component: AllGames,
    protected: true,
    requiredprivileges: [
      'game-content',
      'moderator',
      'marketing',
      'superadmin',
    ],
  },
  {
    path: '/cheaters/access-token',
    component: AccessToken,
    protected: true,
    requiredprivileges: ['moderator', 'superadmin'],
  },
  {
    path: '/cheaters/games-anomaly',
    component: GamesAnomaly,
    protected: true,
    requiredprivileges: ['moderator', 'superadmin'],
  },
  {
    path: '/cheaters/treasure-anomaly',
    component: TreasureAnomaly,
    protected: true,
    requiredprivileges: ['moderator', 'superadmin'],
  },
]
